import { render, staticRenderFns } from "./UserChangePasswordModal.vue?vue&type=template&id=4cebc395&"
import script from "./UserChangePasswordModal.vue?vue&type=script&lang=js&"
export * from "./UserChangePasswordModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports